export default "__VITE_ASSET__CvCpsNTS__"